import { getWidgetMinHeightBySysname } from '../helpers';

export default {
    props: {
        ready: Boolean,
        tabWidget: Object,
    },
    data() {
        return {
            defaultName: this.tabWidget.widget.name,
            tabWidgetSettingsModalID: `tab-widget-settings-modal-id-${this.tabWidget.id}`,
            minHeight: getWidgetMinHeightBySysname(
                this.tabWidget.widget.sysname
            ),
            cardGridKey: 1,
            defaultWidgetFontSize: 12,
        }
    },
    computed: {
        title() {
            return this.tabWidget.settings.name || this.defaultName;
        },
        tabWidgetSettingsInitialValues() {
            return {
                settings: {
                    name: this.tabWidget.settings.name || this.defaultName,
                },
            };
        },
    },
    methods: {
        handleTabWidgetSettingsClick() {
            this.$bvModal.show(this.tabWidgetSettingsModalID);
        },
        handleSuccessTabWidgetSettingsUpdate() {
            this.$emit('success-tab-widget-settings-update', { id: this.tabWidget.id });
        },
        updateTabWidgetSettings(payload) {
            return this.$store.dispatch(
                'dashboard/updateDashboardTabWidgetSettings',
                {
                    id: this.tabWidget.id,
                    ...payload,
                }
            );
        },
        handleResized() {
            this.cardGridKey += 1;
        },
    }
};
